module.exports = __webpack_public_path__ + "img/PP_Sword_0036.d0116dca.png";